export const styles = (theme) => ({
  root: {
    width: "100%",
  },
  rootToolbar: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
  },
  spacer: {
      flex: '1 1 100%',
  },
  actions: {
      color: theme.palette.text.secondary,
      flex: '0 0 auto',
  },
  customeHeadRow: {
    borderTop: "none",
    backgroundColor: "#fff"
  },
  customCell: {
    padding: "16px",
    cursor: "pointer"
},
});
